import { FiX } from 'react-icons/fi';
import InvoiceActionModal from './InvoiceActionModal';
import { useState } from 'react';
import BorderGradient from 'components/shared/BorderGradient/BorderGradient';

interface Invoice {
  id: string;
  invoiceNumber: string;
  customerName: string;
  subscriptionType: string;
  inoviceDate: string;
  amount: string;
  dueDate: string;
  paymentStatus: string;
  paymentMethod: string;
}

interface InvoiceDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  invoice: Invoice | null;
}

export default function ViewInvoiceModal({
  isOpen,
  onClose,
  invoice
}: InvoiceDetailModalProps) {
  if (!isOpen || !invoice) return null;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<"paid" | "schedule" | null>(null);

  const openModal = (type: "paid" | "schedule") => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <BorderGradient className='w-full max-w-4xl'>
        <div className="bg-[#1A1A1A] rounded-lg overflow-y-auto" style={{ maxHeight: 'calc(90vh - 100px)' }}>
          <div className="p-8">
           
            <div className="flex justify-end gap-3 items-center mb-4">
          
              <button className="px-4 py-2 bg-gray-200 rounded-md bg-[#2A2A2A] p-4">
                Resend
              </button>
              <button onClick={() => openModal("paid")} className="px-4 py-2 bg-gray-200 rounded-md bg-[#2A2A2A] p-4">
                Mark as Paid
              </button>
              <button onClick={() => openModal("schedule")} className="px-4 py-2 bg-gray-200 rounded-md bg-[#2A2A2A] p-4">
                Schedule
              </button>

              <div className="flex justify-end">
              <button onClick={onClose} className="p-2 hover:bg-[#2A2A2A] rounded-full text-gray-400 hover:text-white">
                <FiX className="w-5 h-5" />
            </button>
                </div>
              
            </div>

            {/* Invoice Header */}
            <div className="bg-[#2A2A2A] rounded-lg p-6 mb-8">
              <div className="flex justify-between">
                <div>
                  <h1 className="text-2xl font-bold text-white">Invoice</h1>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-400">Invoice No.</div>
                  <div className="text-white">#{invoice.invoiceNumber}</div>
                </div>
              </div>

              <div className="flex justify-between mt-8">
                <div>
                  <div className="text-sm text-gray-400 mb-1">Billed To:</div>
                  <div className="text-white text-2xl">{invoice.customerName}</div>
                  <div className="text-gray-400">
                    1234 Main Street, Suite 200
                    <br />
                    New York, NY, 10001
                    <br />
                    United States
                  </div>
                  <div className="text-gray-400">
                    VAT # 123456789
                  </div>
                </div>
                <div className="text-right space-y-4">
                  <div>
                    <div className="text-sm text-gray-400">Invoice Date</div>
                    <div className="text-white">{invoice.inoviceDate}</div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-400">Due Date</div>
                    <div className="text-white">{invoice.dueDate}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Invoice Items */}
            <div className="mb-8">
              <div className="grid grid-cols-12 text-sm text-gray-400 mb-4">
                <div className="col-span-6">Invoice Item</div>
                <div className="col-span-2 text-center">Qty.</div>
                <div className="col-span-2 text-right">Price</div>
                <div className="col-span-2 text-right">Total</div>
              </div>

              <div className="grid grid-cols-12 text-sm border-b border-white/[0.08] pb-4">
                <div className="col-span-6 text-white">{invoice.subscriptionType}</div>
                <div className="col-span-2 text-center text-gray-400">1</div>
                <div className="col-span-2 text-right text-gray-400">{invoice.amount}</div>
                <div className="col-span-2 text-right text-white">{invoice.amount}</div>
              </div>
            </div>

            {/* Invoice Summary */}
            <div className="flex justify-end">
              <div className="w-64">
                <div className="flex justify-between text-sm mb-2">
                  <span className="text-gray-400">Subtotal</span>
                  <span className="text-white">{invoice.amount}</span>
                </div>
                <div className="flex justify-between text-sm mb-2">
                  <span className="text-gray-400">Discount</span>
                  <span className="text-white">0.00</span>
                </div>
                <div className="flex justify-between text-sm mb-2">
                  <span className="text-gray-400">Tax Rate</span>
                  <span className="text-white">2%</span>
                </div>
                <div className="flex justify-between text-sm mb-4">
                  <span className="text-gray-400">Total Tax</span>
                  <span className="text-white">50.00</span>
                </div>

                <div className="bg-[#2A2A2A] rounded-lg p-4">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Total (USD)</span>
                    <span className="text-xl font-bold text-white">4,050.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BorderGradient>

      <InvoiceActionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        actionType={modalType as "paid" | "schedule"}
      />
    </div>
  );
} 
